import {styled} from '@mui/material'
import {Colors} from 'appearance'
import {React} from 'common'
import Button from 'components/Control/Button'
import RequestsChart from 'components/Display/Dashboard/RequestsChart'
import RequestsStatus from 'components/Display/Dashboard/RequestsStatus'
import {Page, PageContent} from 'components/Page'
import {useI18n} from 'store/Store'
import ChevronLeft from '@mui/icons-material/ChevronLeft'
import RequestsTabs from 'components/Display/Tabs/RequestsTabs'
import useDashboardScreen from 'logic/screens/useDashboardScreen'
import {useDeviceDetect} from 'services/hooks'
import DashboardHeader from 'components/Dashboard/DashboardHeader'
import AddClientButton from 'components/Page/Header/AddClientButton'

const Dashboard = () => {
    const {i18n} = useI18n()
    const {isMobile} = useDeviceDetect()

    const {
        user,
        selectPeriod,
        selectedStatus,
        selectStatus,
        status,
        tableData,
        chartData,
        isLoading,
        clickAllClients,
    } = useDashboardScreen()

    if (isLoading) {
        return <p>Loading...</p>
    }

    return (
        <Page title={''}>
            <DashboardContainerContent isMobile={isMobile}>
                <DashboardHeader user={user} setPeriod={selectPeriod} />
                <DashboardContent isMobile={isMobile}>
                    <FirstSection isMobile={isMobile}>
                        <RequestsStatus
                            data={status || {}}
                            selectedStatus={selectedStatus}
                            onSelectStatus={selectStatus}
                        />
                        {!isMobile && (
                            <RequestsChart
                                title={selectedStatus}
                                data={chartData}
                            />
                        )}
                    </FirstSection>
                    <SecondSection>
                        <RequestsTabs
                            data={tableData}
                            selectedStatus={selectedStatus}
                            setSelectedStatus={selectStatus}
                        />
                        {isMobile && <StyledAddClientButton width={150} />}
                        <AllDataButton
                            endIcon={<ChevronLeft />}
                            onClick={clickAllClients}>
                            {i18n.t('dashboard.all_clients_button')}
                        </AllDataButton>
                    </SecondSection>
                </DashboardContent>
            </DashboardContainerContent>
        </Page>
    )
}

export default Dashboard

const DashboardContainerContent = styled(PageContent)`
    padding: 48px ${({isMobile}) => (isMobile ? 20 : 48)}px;
`

const DashboardContent = styled('div')`
    display: flex;
    flex-direction: ${({isMobile}) => (isMobile ? 'column' : 'row')};
    gap: ${({isMobile}) => (isMobile ? 0 : 48)}px;
    width: 100%;
    height: 100%;
    padding-top: 24px;
`

const FirstSection = styled('div')`
    display: flex;
    flex-direction: column;
    flex: ${({isMobile}) => (isMobile ? 0 : 2)};
    gap: 30px;
    padding-bottom: ${({isMobile}) => (isMobile ? 20 : 48)}px;
`

const SecondSection = styled('div')`
    flex: 1;
    display: flex;
    flex-direction: column;
`

const AllDataButton = styled(Button)`
    align-self: end;
    color: ${Colors.PRIMARY_TEXT};
    & .MuiButton-endIcon {
        margin-inline: 4px;
    }
`

const StyledAddClientButton = styled(AddClientButton)`
    align-self: flex-end;
    margin-top: 20px;
    margin-bottom: 10px;
`
